import React from 'react';
import { connect } from 'react-redux';
import {
  updateSettings,
  deleteComponent,
  sitePublishOrSave,
  onStylesChange,
  onCategoryChecked,
  getFAQContent,
} from '../../actions/widgetActions';

import BiService from '../../services/biService';
import wixService from '../../services/wixService';
import { withTranslation } from 'react-i18next';
import { ContainerBlockStyle } from './styles';
import FixedHeightView from './components/modules/viewer/fixed-height';
import AdjustHeightView from './components/modules/viewer/adjust-height';
import FixedHeightViewWithoutCategorie from './components/modules/viewer/fixed-height-withoutCategories';
import AdjustHeightViewWithoutCategorie from './components/modules/viewer/adjust-height-withoutCategories';
import EmptyState from '../common/emptyState/emptyState';

import './styles/widget.global.scss';

const biService = new BiService(wixService);
biService.init();

class Widget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inited: false,
      settings: props.settings,
      wixStyleParams: {},
      deepLink: {
        isEnable: false,
        questionUrl: '',
      },
      isTitleLoad: false,
    };
    this.handleResize = this.handleResize.bind(this);
    this.mainContainerRef = React.createRef();
    this.componentDidMount.bind(this);
    this.handleStylesChangeEvent = this.handleStylesChangeEvent.bind(this);
    this.getSizeKey = this.getSizeKey.bind(this);
    this.initApp = this.initApp.bind(this);
    this.saveAppSizeInPublicData = this.saveAppSizeInPublicData.bind(this);
    this.resizeApp = this.resizeApp.bind(this);
    this.getWindowDimensions = this.getWindowDimensions.bind(this);
    this.setTextsValue(this.getKey(props.settings.language));
  }

  getKey(lang) {
    return `faq_${lang}_${wixService.getCookieKey('')}`;
  }

  setTextsValue(Key) {
    wixService
      .getWixPublicData(Key)
      .then((d) => {
        const settings = this.state.settings;
        settings.title.text = d[Key].title || this.state.title;
        settings.searchBar.text = d[Key].searchBar || this.state.searchBar;
        this.setState({ isTitleLoad: true ,settings});
      })
      .catch(() => {
        this.setState({ isTitleLoad: true });
      });
  }

  getWindowDimensions() {
    return {
      h: window.innerHeight,
      w: window.innerWidth,
    };
  }

  saveAppSizeInPublicData(wSize) {
    const sizeAppKey = this.getSizeKey();

    try {
      wixService.setWixPublicData(sizeAppKey, JSON.stringify(wSize));
    } catch (err) {
      // console.log('faq_app_size_ err', err);
    }
  }

  resizeApp(isResizeBind) {
    const that = this;
    let w = 0;
    if (wixService.isEditorMode()) {
      const windowDimensions = that.getWindowDimensions();
      const wSize = { h: 0, w: 0 };
      wSize.h = windowDimensions.h;
      wSize.w = windowDimensions.w;

      if (that.isMobile) {
        w = windowDimensions.w || 0;
        if (!that.isEditorX) {
          if (windowDimensions.w < 280) {
            w = 280;
          } else if (windowDimensions.w > 320) {
            w = 320;
          }
        }
        // wixService.resizeComponent({
        //   width: w,
        // });
      } else if (windowDimensions.w < 320) {
        if (!that.isEditorX) {
          wSize.w = 320;
          // wixService.resizeComponent({
          //   width: 320,
          // });
        }
      } else if (!this.state.inited) {
        wSize.w = wixService.Utils.getWidth();
        if (that.isEditorX) {
          if (isNaN(wSize.w)) {
            // width is undefined or isn't number
            const windowSize = that.getWindowDimensions();
            wSize.w = windowSize.w;
          }
        }

        // wixService.resizeComponent({
        //   width: wSize.w,
        // });
      }

      if (this.props.settings.isFixedHeight) {
        if (!that.state.isEditorX) {
          if (windowDimensions.h < 200) {
            wSize.h = 200;
            // window.Wix.setHeight(wSize.h);
          }
        } else {
          that.saveAppSizeInPublicData(wSize);
          window.Wix.setHeight(wSize.h);
        }
      }

      if (isResizeBind && !that.props.isMobile && !that.state.isEditorX) {
        that.saveAppSizeInPublicData(wSize);
      }
    }
  }

  handleResize(width, height) {
    // const wSize = {w: width, h: height};
    // this.saveAppSizeInPublicData(wSize);
    // this.resizeApp(true, width, height);
  }
  initApp(needUpdateFaqItems) {
    this.resizeApp();

    if (needUpdateFaqItems || !this.state.inited) {
      if (wixService.isEditorMode() && !this.state.inited) {
        let width = wixService.Utils.getWidth();

        if (this.state.isEditorX) {
          if (isNaN(width)) {
            // width is undefined or isn't number
            const windowSize = this.getWindowDimensions();
            width = windowSize.w;
          }
        }

        // if (!isNaN(width) || typeof width === 'number') {
        //   wixService.resizeComponent({
        //     width,
        //   });
        // }
      }

      this.setState({ inited: true });
    }
  }

  handleStylesChangeEvent() {
    const that = this;
    return function (myStyleParams) {
      myStyleParams = myStyleParams || that.state.wixStyleParams;
      const styleParams = myStyleParams;
      styleParams.colors = myStyleParams.colors || {};
      styleParams.fonts = myStyleParams.fonts || {};
      const isEditorX = !!myStyleParams.booleans.responsive;
      that.setState({ wixStyleParams: styleParams, isEditorX });
      that.props.onStylesChange(styleParams);
    };
  }

  getSizeKey() {
    return (
      'faq_app_' +
      (wixService.isMobile() ? 'mobile' : 'widget') +
      '_size_' +
      wixService.getCookieKey('')
    );
  }

  componentDidMount() {
    this.props.getFAQContent(this.props.settings.manageCategories.categories);
    this.initApp();

    window.addEventListener('resize', () => {
      this.resizeApp(true);
    });

    wixService.Styles.getStyleParams(this.handleStylesChangeEvent());
    wixService.addEventListener(
      wixService.Events.STYLE_PARAMS_CHANGE,
      this.handleStylesChangeEvent(),
    );

    wixService.getSiteInfo((siteInfo) => {
      // for Deeplink
      const url = siteInfo && siteInfo.url ? siteInfo.url : '';
      const queryString = url.split('?')[1];
      const urlParams = new URLSearchParams(queryString);
      if (urlParams.has('questionId')) {
        const questionId = wixService.stripTags(urlParams.get('questionId'));
        this.setState({
          deepLink: {
            isEnable: true,
            questionId,
          },
        });
      }
    });
    wixService.addEventListener(
      wixService.Events.EDIT_MODE_CHANGE,
      function () {
        if (wixService.isEditorMode()) {
          window.location.reload(false);
        }
      },
    );
    wixService.addEventListener(
      wixService.Events.SETTINGS_UPDATED,
      async (settings) => {
        if (
          settings.keyName &&
          settings.keyName === 'manageCategories.categories'
        ) {
          const isNotQuestionsForCategoryIdExist =
            this.props.faqList.categories.some((cat) => {
              return (
                cat.id === settings.currentSelectedCategoryId &&
                !cat.hasOwnProperty('questionsList')
              );
            });

          if (isNotQuestionsForCategoryIdExist) {
            await this.props.onCategoryChecked(
              settings.currentSelectedCategoryId,
              this.props.faqList,
            );
          }
        }

        const oldSettings = this.state.settings;
        this.setState({ settings });
        this.props.onSettingsUpdate(settings, wixService.Utils.getCompId());
        if (
          !oldSettings.isFixedHeight &&
          settings.heightApp ===
            window.initialState.constants.HEIGHT_APP.FIXED &&
          wixService.isEditorMode()
        ) {
          const height = this.state.isEditorX
            ? this.getWindowDimensions().h
            : 460;
          window.Wix.setHeight(height);
        }

        this.initApp(true);
      },
    );
    wixService.addEventListener(wixService.Events.COMPONENT_DELETED, () => {
      this.props.onComponentDelete();
    });
    wixService.addEventListener(wixService.Events.SITE_PUBLISHED, () => {
      this.props.onSitePublishOrSave(this.props.settings, this.props.faqList);
    });
  }

  render() {
    const { design, styleParams, faqList, constants } = this.props;
    const { isError, isNoFAQs, isNoCategorySelectedMessage } = faqList;
    const settings = {
      ...this.props.settings,
      isError,
      isNoFAQs,
      isNoCategorySelectedMessage,
    };

    if (!faqList?.isLoad) {
      return <></>;
    }
    let isNoCategories = false;
    const { isTitleLoad } = this.state;
    const LAST_CATEGORY_ID_FOR_MIGRATION = ['11111', '22222', '33333'];

    const isAnyCategoryChanged = faqList.categories.some(
      (cat) =>
        Math.abs(new Date(cat.updatedDate) - new Date(cat.createdDate)) / 36e5 >
        3,
    );
    if (
      (settings.hasOwnProperty('manageCategories') &&
        settings.manageCategories.categories.length &&
        settings.manageCategories.categories.some((manageCat) =>
          LAST_CATEGORY_ID_FOR_MIGRATION.includes(
            manageCat.slice(manageCat.length - 5),
          ),
        ) &&
        !isAnyCategoryChanged) ||
      settings.displayContent ===
        constants.DISPLAY_CONTENT.ONE_LIST_OF_QUESTIONS
    ) {
      isNoCategories = true;
    }

    if (
      wixService.isSiteMode() &
      (settings.isError || settings.isNoCategorySelectedMessage)
    ) {
      return <></>;
    }

    return isTitleLoad ? (
      <ContainerBlockStyle
        design={design}
        styleParams={styleParams}
        settings={settings}
        className={settings.mainClassesName}
        ref={this.mainContainerRef}
      >
        {faqList.questions.length === 0 ? (
          <EmptyState
            isSiteMode={wixService.isSiteMode()}
            styleParams={styleParams}
            design={design}
            settings={settings}
          />
        ) : isNoCategories ? (
          settings.isFixedHeight ? (
            <>
              <FixedHeightViewWithoutCategorie
                className="fixedHeightView"
                handleResize={this.handleResize}
                deepLink={this.state.deepLink}
              />
            </>
          ) : (
            <>
              <AdjustHeightViewWithoutCategorie
                className="adjustHeightView"
                handleResize={this.handleResize}
                deepLink={this.state.deepLink}
              />
            </>
          )
        ) : settings.isFixedHeight ? (
          <>
            <FixedHeightView
              className="fixedHeightView"
              handleResize={this.handleResize}
              deepLink={this.state.deepLink}
            />
          </>
        ) : (
          <>
            <AdjustHeightView
              className="adjustHeightView"
              handleResize={this.handleResize}
              deepLink={this.state.deepLink}
            />
          </>
        )}
      </ContainerBlockStyle>
    ) : (
      <></>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

const mapDispatchToProps = (dispatch) => ({
  onSettingsUpdate: (update) => dispatch(updateSettings(update)),
  onCategoryChecked: (categoryId, faqList) =>
    dispatch(onCategoryChecked(categoryId, faqList)),
  getFAQContent: (manageCategories) =>
    dispatch(getFAQContent(manageCategories)),
  onComponentDelete: () => dispatch(deleteComponent()),
  onSitePublishOrSave: (settings, faqList) =>
    dispatch(sitePublishOrSave(settings, faqList)),
  onStylesChange: (styleParams) => dispatch(onStylesChange(styleParams)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Widget));
